import type { Suggestion } from '../hooks/use-template-autocomplete';

export type TemplateAutocompleteListProps = {
  suggestions: Suggestion[];
  selectedIndex: number;
  onSelect: (value: string) => void;
  isOpen: boolean;
};

export function TemplateAutocompleteList({
  suggestions,
  selectedIndex,
  onSelect,
  isOpen,
}: TemplateAutocompleteListProps) {
  if (!isOpen || suggestions.length === 0) return null;

  return (
    <ul
      role='listbox'
      className='absolute z-50 mt-1 max-h-48 w-full overflow-y-auto rounded-md border bg-popover p-1 shadow-md'
    >
      {suggestions.map((suggestion, index) => (
        <li
          key={suggestion.value}
          role='option'
          aria-selected={index === selectedIndex}
          ref={
            index === selectedIndex ? (el) => el?.scrollIntoView({ block: 'nearest' }) : undefined
          }
          className={`flex items-center justify-between cursor-pointer rounded-sm px-2 py-1.5 text-sm ${
            index === selectedIndex ? 'bg-accent text-accent-foreground' : ''
          }`}
          onMouseDown={(e) => {
            e.preventDefault();
            onSelect(suggestion.value);
          }}
        >
          <span className='font-mono'>{suggestion.value}</span>
          <span className='text-xs text-muted-foreground ml-2'>{suggestion.type}</span>
        </li>
      ))}
    </ul>
  );
}
